import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CacheService {

  private cacheKey = 'httpCache';

  constructor() { }

  put(url: string, response: any){
    const cache = this.getCache();

    cache[url] = response;

    sessionStorage.setItem(this.cacheKey, JSON.stringify(cache));
  }

  get(url: string): any{
    const cache = this.getCache();
    
    return cache[url] || null;
  }

  clear(){
    sessionStorage.removeItem(this.cacheKey);
  }

  private getCache(): Record<string, any>{
    const cache = sessionStorage.getItem(this.cacheKey);

    return cache ? JSON.parse(cache) : {};
  }
}